module.exports = {

    /**
     * @public
     */
    useCoverPlaceholderImage: false,

    /**
     * Resolves the formFactor of the header based on mediaItem type.
     *
     * Current options include:
     * - `default`  Default slides, used for mediaItem types which display a
     *              header above a dashboard or a list of serial content.
     * - `tall`     Tall slides, used for mediaItem types which display a
     *              viewport-filling headers for non-serial content.
     *
     * @param   {Object}  mediaItem  The form-factor
     * @return  {string}  The formFactor of the header
     * @public
     */
    getSliderSize: function(mediaItem) {
        switch (mediaItem.type) {
            case "audio":
            case "book":
            case "video":
                return "tall";
            case "brand":
            case "category":
            case "magazine":
            case "music_album":
            case "page":
            case "podcast":
            case "product":
            case "product_category":
            case "series":
            default:
                return "default";
        }
    },

    /**
     * Where to align the content within the header.
     *
     * Available options:
     *  - `top`
     *  - `middle`
     *  - `bottom`
     *
     * @param   {Object}  mediaItem  The form-factor
     * @return  {string}  The alignment
     * @public
     */
    getHeaderDescriptionAlignment: function(mediaItem) {
        switch (mediaItem.type) {
            case "audio":
            case "book":
            case "brand":
            case "category":
            case "magazine":
            case "music_album":
            case "page":
            case "podcast":
            case "product":
            case "product_category":
            case "series":
            case "video":
            default:
                return "middle";
        }
    },

    /**
     * Resolves the formFactor of the cover based on mediaItem type.
     *
     * Available options:
     *  - `landscape`
     *  - `square`
     *  - `portrait`
     *  - `undefined` (no cover)
     *
     * @param   {Object}   mediaItem  The form-factor
     * @return  {?string}  The formFactor of the cover
     * @public
     */
    getCoverFormFactor: function(mediaItem) {
        switch (mediaItem.type) {
            case "album_track":
            case "audio":
            case "music_album":
            case "podcast":
            case "podcast_episode":
                return "square";
            case "book":
            case "brand":
            case "category":
            case "episode":
            case "issue":
            case "magazine":
            case "page":
            case "photo":
            case "product":
            case "product_category":
            case "series":
            case "video":
                return "portrait";
            default:
                return null;
        }
    },

    /**
     * Resolves if the header should show a sign-up button.
     *
     * @param   {Object}   mediaItem  The form-factor
     * @return  {?string}  The visibility
     * @public
     */
    getSignUpButtonVisibility: function(mediaItem) {
        return [
            "album_track", "audio", "book", "episode", "issue", "magazine", "music_album", "photo", "podcast", "podcast_episode", "series", "video"
        ].includes(mediaItem);
    }

};
